const module = document.getElementsByTagName('html')[0]
const webshopName = module.getAttribute('data-webshop')

export default webshopName
